import React from 'react'
import './CommercialServicesCard.scss'
/**
 * A loading placeholder for the Commercial Services Card.
 * This component displays a grey placeholder box while the actual content is loading.
 * 
 * @component
 * @memberof Components
 * 
 * @returns {JSX.Element} A loading skeleton for the Commercial Services Card.
 */
const CommercialServicesCardLoading = () => {

    return (
        <div className="commercial-services-card commercial-services-card--loading">
            <div className="commercial-services-card__header" />
            <div style={{ height: '260px', background: 'linear-gradient(90deg, #f1f5f9 25%, #e8edf3 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'cfc-shimmer 1.4s infinite' }} />
        </div>
    )
}

export default CommercialServicesCardLoading